import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import {
  $authStatus,
  getUserInfoEv,
  setAuthEv,
} from './models/authModel/index.js';
import { cookies } from './api/axiosinstance.js';
import ContentContainer from './components/ContentContainer/ContentContainer.jsx';
import { lightTheme } from './theme/themeConfig.js';
import { $loader, getHexCollectionFx } from './models/logicModel/index.js';

function App() {
  const authStatus = useUnit($authStatus);
  const location = useLocation();
  const navigate = useNavigate();
  const setAuth = useUnit(setAuthEv);
  const getUserInfo = useUnit(getUserInfoEv);
  const getHexCollectionPending = useUnit(getHexCollectionFx.pending);
  const loader = useUnit($loader);

  const loading = getHexCollectionPending || loader;

  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/root');
      getUserInfo();
    }
  }, [location]);

  useEffect(() => {
    if (!authStatus) {
      const token = cookies.get('access_token');
      if (!token) {
        navigate('/login');
      } else {
        setAuth(true);
      }
    }
    getUserInfo();
  }, [authStatus]);

  return (
    <ConfigProvider theme={lightTheme}>
      <Spin spinning={loading}>
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </Spin>
    </ConfigProvider>
  );
}

export default App;
